const defaultFields = [
  //'commands',
  {
    key: 'id',
    field: 'id',
    title: 'Id',
    label: 'id',
    width:'40px',
    sortable: true
	 },
  {
    key: 'dateCreated',
    field: 'dateCreated',
    title: 'Created',
    label: 'dateCreated',
    width:'200px',
    sortable: true
	 },
  {
    key: 'firstname',
    field: 'firstname',
    title: 'First',
    label: 'firstname',
    sortable: true
	 },
  {
    key: 'lastname',
    field: 'lastname',
    title: 'Last',
    label: 'lastname',
    sortable: true
	 },
	 {
    key: 'email',
    field: 'email',
    title: 'Email',
    label: 'email',
    sortable: true
	 },
  {
    key: 'status',
    field: 'status',
    title: 'Status',
    label: 'status',
    width: '70px',
    sortable: true
	 },
	 {
    key: 'statusDateTime',
    field: 'statusDateTime',
    title: 'As of',
    label: 'statusDateTime',
    width:'200px',
    sortable: true
	 },
  {
    key: 'uri',
    field: 'uri',
    title: 'Link',
    label: 'uri',
    sortable: true
	 },
]

export default defaultFields;
